export const regionalOverview = {
  defaultYear: "السنة الافتراضية",
  selectYear: "حدد السنة للمقارنة",
  selectedYear: "السنة المختارة",
  note: "* ملاحظة: البيانات الواردة في هذه الرسوم البيانية تمثل المعلومات التي تم اعتمادها من قبل الحكومة.",
};
